'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cs_CZ = require('../../date-picker/locale/cs_CZ');

var _cs_CZ2 = _interopRequireDefault(_cs_CZ);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _cs_CZ2["default"];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/calendar/locale/cs_CZ.tsx
 ** module id = 730
 ** module chunks = 1
 **/